import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  useTheme,
  Divider,
  Button,
  IconButton,
  useMediaQuery,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { CancelOutlined, AddCircleOutline, Close } from "@material-ui/icons";
import PropTypes from "prop-types";
import "./table.css";
import {
  CustomHeader,
  Gender,
  Language,
} from "../../../assets/translation_config/custom_header";
import Constant from "../../../helper/constant.json";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  right: {
    textAlign: "right",
    color: theme.palette.text.secondary,
  },
  left: {
    padding: theme.spacing(1),
    textAlign: "left",
    color: theme.palette.text.secondary,
  },
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  flex: {
    display: "flex",
  },
  padding: {
    marginLeft: theme.spacing(5),
  },
  marginTop: {
    marginTop: theme.spacing(1),
  },
  marginLeft: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(4),
  },
  footer: {
    position: "absolute",
    bottom: 0,
    background: theme.palette.text.disabled,
    padding: theme.spacing(1),
    display: "block",
  },
  footer_save: {
    float: "right",
  },
}));

const TranslationComponent = ({
  setList,
  heading,
  headerCollection,
  updateGridHeader,
  removeElementFromHeaderCol,
  addHeaders,
  onSave,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("xs"));

  const removeElement = (e, index) => {
    removeElementFromHeaderCol(index);
  };

  useEffect(() => {
    if (
      headerCollection &&
      headerCollection.length > 0 &&
      localStorage.getItem(Constant.LocalStorageCustomHeaderItem)
    ) {
      let getCollection =
        localStorage.getItem(Constant.LocalStorageCustomHeaderItem) &&
        JSON.parse(localStorage.getItem(Constant.LocalStorageCustomHeaderItem));
      updateGridHeader(getCollection);
    }
  }, []);

  const updateHeaderCol = (index, value = undefined) => {
    let targetVal = index?.target?.name || index;
    if (index && targetVal) {
      let targetSplitVal = targetVal.split("-");
      headerCollection[targetSplitVal[1]][targetSplitVal[0]] =
        index?.target?.value || value;
      updateGridHeader(headerCollection);
    }
  };

  const updateConstantOptionalPanel = (index) => {
    if (headerCollection[index].headerKey?.includes(Constant.Gender)) {
      return Gender.map((option) => option.label);
    } else if (headerCollection[index].headerKey?.includes(Constant.Language)) {
      return Language.map((option) => option.label);
    } else {
      return [];
    }
  };

  return (
    <div>
      <Grid
        container
        xs={12}
        md={12}
        lg={12}
        style={
          isMatch === true
            ? {
                height: "100%",
                width: "200px",
              }
            : {
                textAlign: "center",
                // width: "100%",
                borderBlockColor: "black",
                // margin: "auto",
                height: "100%",
                // overflow:"hidden",
                width: "1000px",
              }
        }
      >
        <Grid
          xs={12}
          md={12}
          lg={12}
          container
          style={{
            backgroundColor: "#3f51b5",
            height: "70px",
            marginBottom: "25px",
          }}
        >
          <Grid xs={10} md={10} lg={10} item>
            <Typography
              style={{
                marginTop: "3vh",
                fontWeight: "bold",
                color: "white",
                fontSize: "19px",
                marginBottom: "3vh",
                textAlign: "center",
                overflowY: "hidden",
              }}
            >
              {heading}
            </Typography>
          </Grid>

          <Grid xs={1} md={1} lg={1} item className={classes.flex}>
            <IconButton onClick={addHeaders} className={classes.marginTop}>
              <AddCircleOutline />
            </IconButton>
            <IconButton
              className={classes.marginTop}
              onClick={() => {
                setList(false);
              }}
            >
              <CancelOutlined />
            </IconButton>
          </Grid>

          <Divider />
          {headerCollection && headerCollection.length > 0 ? (
            headerCollection.map((collection, index) => {
              return (
                <Grid item xs={12} key={index}>
                  <Paper className={classes.left}>
                    <form
                      className={classes.root}
                      noValidate
                      autoComplete="off"
                    >
                      <div className={classes.flex}>
                        <div>
                          <Autocomplete
                            freeSolo
                            disableClearable
                            options={CustomHeader.map((option) => option.label)}
                            id={`header-${index}`}
                            value={collection.headerKey}
                            disablePortal
                            onChange={(event, newValue) => {
                              updateHeaderCol(`headerKey-${index}`, newValue);
                            }}
                            sx={{ width: 400 }}
                            renderInput={(params) => (
                              <TextField
                                id={`header-${index}`}
                                name={`headerKey-${index}`}
                                {...params}
                                onChange={(e) => updateHeaderCol(e)}
                                label={Constant.HeaderKeyLabel}
                                margin="normal"
                              />
                            )}
                          />
                        </div>
                        <div className={classes.padding}>
                          <Autocomplete
                            freeSolo
                            disableClearable
                            options={updateConstantOptionalPanel(index)}
                            id={`header-${index}`}
                            value={collection.headerValue}
                            disablePortal={false}
                            onChange={(event, newValue) => {
                              updateHeaderCol(`headerValue-${index}`, newValue);
                            }}
                            sx={{ width: 400 }}
                            renderInput={(params) => (
                              <TextField
                                id={`value-${index}`}
                                name={`headerValue-${index}`}
                                {...params}
                                onChange={(e) => updateHeaderCol(e)}
                                label={Constant.HeaderValueLabel}
                                margin="normal"
                                value={collection.headerValue}
                              />
                            )}
                          />
                        </div>
                        <div>
                          <IconButton
                            className={classes.marginLeft}
                            onClick={(e) => removeElement(e, index)}
                          >
                            <Close />
                          </IconButton>
                        </div>
                      </div>
                    </form>
                  </Paper>
                </Grid>
              );
            })
          ) : (
            <Grid xs={12} md={12} lg={12} item>
              <p>
                {Constant.AddCustomHeaderText}
                <IconButton onClick={addHeaders}>
                  <AddCircleOutline />
                </IconButton>
              </p>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid xs={12} md={12} lg={12} container item className={classes.footer}>
        <Button
          variant="contained"
          color="primary"
          className={classes.footer_save}
          onClick={onSave}
        >
          Save
        </Button>
      </Grid>
    </div>
  );
};

TranslationComponent.propTypes = {
  setList: PropTypes.any,
  heading: PropTypes.string,
  header: PropTypes.any,
  headerCollection: PropTypes.any,
  updateGridHeader: PropTypes.any,
  headerValue: PropTypes.any,
  removeElementFromHeaderCol: PropTypes.any,
  addHeaders: PropTypes.any,
  onSave: PropTypes.any,
};

export default TranslationComponent;
